document.addEventListener('turbo:load', function() {
  // Checkbox for dossier select
  $('body').on('click', '.checkbox-child-select', function() {
    $(this).toggleClass('checkbox-child-select--active');
    const $checkbox = $(this).find('.checkbox-child-select__hidden-checkbox');
    $checkbox.prop('checked', !$checkbox.prop('checked'));
  });
});
